import clsx from "clsx";
import { GroupBase, OptionProps } from "react-select";

const FormSearchDropdownOption = ({ 
    children, 
    innerProps, 
    innerRef, 
    isSelected,
    isDisabled,
}: OptionProps<unknown, boolean, GroupBase<unknown>>) => (
    <div
        ref={innerRef}
        className={clsx(
            "relative cursor-default select-none py-2 px-4 bg-red",
            !isDisabled && "hover:bg-surface-accent",
            isSelected && "bg-surface-accent",
            isDisabled && "text-[gray]",
        )}
        {...innerProps}
    >
        {children}
    </div>
);

export default FormSearchDropdownOption;